export default __webpack_public_path__ + "static/media/badge-znsbr-m.522dcb43.png";